export const GRID_ITEMS_DESKTOP = 6;
export const GRID_ITEMS_MOBILE = 4;
